import { Injectable } from '@angular/core';
import { Usuario } from '@tivic-team/manager-ts/dist/seg/entities/usuario.entity';
import { LoginController } from 'app/controllers/seg/login.controller';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from './local-storage.service';
var md5 = require('md5');

@Injectable({
    providedIn: 'root'
})
export class LoginService {

    constructor(
        private loginController: LoginController,
        private localService: LocalStorageService
    ) { }

    async login(login: string, senha: string): Promise<Usuario> {
        if (environment.encryptType == 'old')
            senha = this.encrypt(senha.toUpperCase(), 10)
        else if (environment.encryptType == 'md5')
            senha = md5(environment.saltMD5 + senha.toUpperCase())
        let loginReturn = await this.loginController.login(login.toUpperCase(), senha);

        return loginReturn;
    }

    public encrypt(value: string, number: number): string {
        let result: string = '';
        for (let i: number = 0; i < value.length; i++) {

            let char: string = value.charAt(i);
            for (let encIndex: number = 0; encIndex < number; encIndex++) {
                char = String.fromCharCode(char.charCodeAt(0) + 1);
            }
            result += char;
        }

        return result;
    }

    public deecrypt(value: string, number: number): string {
        let result: string = '';
        for (let i: number = 0; i < value.length; i++) {

            let char: string = value.charAt(i);
            for (let encIndex: number = 0; encIndex < number; encIndex++) {
                char = String.fromCharCode(char.charCodeAt(0) - 1);
            }
            result += char;
        }

        return result;
    }


    public salvarSessao(usuario: Usuario, login: string = null, senha: string = null) {
        this.localService.setValue('usuario', JSON.stringify(usuario));
        this.localService.setValue('token', usuario.token);

        if (login && senha) {
            this.localService.setValue('lgSalvarSenha', true);
            this.localService.setValue('login', login);
            this.localService.setValue('senha', btoa(senha));
        } else {
            this.localService.setValue('lgSalvarSenha', null);
            this.localService.setValue('login', null);
            this.localService.setValue('senha', null);
        }
    }

    async logout (usuario: string) {
        await this.loginController
        .logout(usuario)
        .then(() => {
            window.localStorage.clear();
            window.sessionStorage.clear();
            location.reload();
        });
    }

}
